/**
 * Constants and default values for service recurrence functionality
 */

/**
 * Map day key to day-of-week number for date-fns
 */
export const DAY_KEY_TO_NUMBER = {
  sun: 0,
  mon: 1,
  tue: 2,
  wed: 3,
  thurs: 4,
  fri: 5,
  sat: 6,
}

/**
 * Shared default selected days object so we don't duplicate literal everywhere
 */
export const DEFAULT_SELECTED_DAYS = {
  sun: false,
  mon: false,
  tue: false,
  wed: false,
  thurs: false,
  fri: false,
  sat: false,
}

/**
 * Shared default required days object for required checkboxes
 */
export const DEFAULT_REQUIRED_DAYS = {
  sun: false,
  mon: false,
  tue: false,
  wed: false,
  thurs: false,
  fri: false,
  sat: false,
}

/**
 * Days of week option list used by days selector component
 */
export const DAYS_OF_WEEK = [
  { key: 'sun', label: 'Sun', value: 0 },
  { key: 'mon', label: 'Mon', value: 1 },
  { key: 'tue', label: 'Tue', value: 2 },
  { key: 'wed', label: 'Wed', value: 3 },
  { key: 'thurs', label: 'Thurs', value: 4 },
  { key: 'fri', label: 'Fri', value: 5 },
  { key: 'sat', label: 'Sat', value: 6 },
]

/**
 * Day name to key mapping for backend integration
 */
export const DAY_NAME_TO_KEY = {
  Sunday: 'sun',
  Monday: 'mon',
  Tuesday: 'tue',
  Wednesday: 'wed',
  Thursday: 'thurs',
  Friday: 'fri',
  Saturday: 'sat',
}

/**
 * Day key to Java DayOfWeek enum mapping for API payload
 */
export const DAY_KEY_TO_ENUM = {
  sun: 'Sunday',
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thurs: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
}

/**
 * Event status enum for recurrence event changes
 */
export const EVENT_STATUS = {
  EXISTING: 'existing',
  NEW: 'new',
  REMOVED: 'removed',
}

export default {
  DAY_KEY_TO_NUMBER,
  DEFAULT_SELECTED_DAYS,
  DEFAULT_REQUIRED_DAYS,
  DAYS_OF_WEEK,
  DAY_NAME_TO_KEY,
  EVENT_STATUS,
}
